import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import { TranscriptService } from '../../../../../teams-call/core/transcript.service';
import { ActionType } from '../transcript-summary.action';

import {
    DeleteTranscript,
    deleteTranscriptResult,
} from './delete-transcript.action';

export const deleteTranscriptEpic = (
    action: ActionsObservable<PayloadAction<ActionType, DeleteTranscript>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TS__DELETE_TRANSCRIPT),
        mergeMap((act: PayloadAction<ActionType, DeleteTranscript>) => {
            const tsService =
                deps.injector.get<TranscriptService>(TranscriptService);

            return tsService.delete(act.payload.transcriptId).pipe(
                map(() => {
                    return deleteTranscriptResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
